module.exports = __webpack_public_path__ + "static/media/search.c2b5a1f9.svg";